import { Component, EventEmitter, Output } from '@angular/core';
import { DialogService } from 'src/app/core/dialog.service';
import { VopRequestNewCheckDialogComponent } from '../vop-request-new-check-dialog/vop-request-new-check-dialog.component';

@Component({
  selector: 'app-vop-request-header',
  templateUrl: './vop-request-header.component.html',
  styleUrls: ['./vop-request-header.component.scss'],
})
export class VopRequestHeaderComponent {
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  @Output() filter: EventEmitter<void> = new EventEmitter<void>();
  constructor(private dialog_service: DialogService) {}
  onNewCheckClick() {
    this.dialog_service
      .openDialog(VopRequestNewCheckDialogComponent)
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }
      });
  }
}
